import { Icon } from "@/components/msd/Icon";
import { cx, initialsOf } from "@/components/msd/ui";
import { vehicleImageFor } from "../../lib/msdVehicles";

// The picture beside a conversation: the catalog photo for the group's vehicle,
// else a car tile when the model is known but has no photo, else the customer's
// initials. `round` is the chat header's circle; the default is the list tile,
// which only a photo fills, so without one the list gets the circle too.
// Soft tints for the initials circle, WhatsApp-style but quieter: [background, text].
const TINTS = [
  ["#E3EEFF", "#1F5596"],
  ["#DCF5E7", "#15803D"],
  ["#FDE8D7", "#C2410C"],
  ["#F1E6FF", "#7E22CE"],
  ["#FDE3EC", "#BE185D"],
  ["#D9F3F5", "#0E7490"],
  ["#FBF0C9", "#A16207"],
  ["#E4E7FB", "#4338CA"],
];

// The same name always gets the same tint.
function tintFor(name) {
  let sum = 0;
  for (const ch of String(name || "")) sum += ch.codePointAt(0);
  return TINTS[sum % TINTS.length];
}

export default function VehicleThumb({ group, catalog, name, round = false, className }) {
  const model = vehicleImageFor(group, catalog);
  const src = model?.thumb_url || model?.hero_url;
  const box = cx(
    "shrink-0 bg-[#EEF0F4] shadow-msd-e1",
    round || !src ? "h-11 w-11 rounded-full" : "h-[52px] w-16 rounded-xl",
    className,
  );
  if (src) return <img src={src} alt="" loading="lazy" className={cx(box, "object-cover")} />;
  const [background, color] = tintFor(name);
  return (
    <span
      className={cx(box, "flex items-center justify-center text-[13px] font-semibold")}
      style={{ background, color }}
      aria-hidden="true"
    >
      {model ? <Icon name="car" size={20} /> : initialsOf(name) || "–"}
    </span>
  );
}
